<template lang="pug">
div
  #waiting-review.tab-pane.fade.show(
    aria-labelledby='settings-tab'
    role='tabpanel'
  )
    .row(v-if='!showFeedbackNoEnvelopes')
      .mb-3.col-12.col-lg-6.col-xl-5
        .form-control-icon--end-line.flex-grow-1
          input.form-control.rounded-3(
            :placeholder='$t("placeholder.search_envelopes")'
            @input='searchEnvelopesArchived()'
            autocomplete='off'
            v-model='search'
          )
          icon.icon--blue.font-size-subtitle(name='magnifying-glass')
    .row(v-if='!showFeedbackNoEnvelopes')
      .col-12
        waiting-review-envelopes-card-table.mb-5(
          :data='envelopesArchived.data'
          @item-deleted='refreshAfterDelete'
          @refresh='refreshEnvelopeWaitingReview'
          @sort='setSortColumn'
        )
        simple-paginator(
          :payload='envelopesArchived'
          @navigate='fetchEnvelopeWaitingReview'
        )
    .text-center.mt-5(v-if='showFeedbackNoEnvelopes')
      img.img(
        src='/img/ilustrations/no-drafts-found.svg'
        style='max-height: 260px'
      )
      .mt-4.text-center {{ $t('pages.waiting-review.noEnvelopes') }}

    .text-center.mt-5(v-if='showFeedbackNoResults')
      img.img-fluid(src='/img/ilustrations/no-contacts-found.svg')
      p.font-color-blue.text-center.mt-4
        | {{ $t('pages.waiting-review.noResults') }}
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import debounce from 'debounce';
import SimplePaginator from '@/ui/organisms/SimplePaginator.vue';
import TableComponent from '@/ui/organisms/Table.vue';
import WaitingReviewEnvelopesCardTable from '@/modules/business/components/organisms/card-table/WaitingReviewEnvelopesCardTable.vue';
import { getAllowedVisibilities } from '@/modules/business/common/envelopeVisibility';

export default {
  name: 'DocumentsPage',
  components: {
    Icon,
    SimplePaginator,
    TableComponent,
    WaitingReviewEnvelopesCardTable,
  },
  data() {
    return {
      envelopesArchived: {
        data: [],
        links: {},
        meta: {},
      },
      filters: {
        sort: '-created_at',
      },
      search: '',
    };
  },
  async created() {
    const teamsVisibilityConfig = getAllowedVisibilities(
      this.$store.state.organizations.selected
    );

    if (teamsVisibilityConfig.length === 0) {
      return this.$router.replace({ name: 'business.dashboard' });
    }

    this.updatePageTitleAndHead();
    this.$store.dispatch('page/setClass', 'business documents');
    this.fetchEnvelopeWaitingReview();
  },
  computed: {
    isEmptyList() {
      return this.envelopesArchived.data.length === 0;
    },
    isSearching() {
      return this.search.length > 0;
    },
    showFeedbackNoEnvelopes() {
      return this.isEmptyList && !this.isSearching;
    },
    showFeedbackNoResults() {
      return this.isEmptyList && this.isSearching;
    },
  },
  methods: {
    updatePageTitleAndHead() {
      this.$store.dispatch(
        'page/setTitle',
        this.$t('pages.waiting-review.title')
      );
      this.$store.dispatch('page/setHead', {
        title: this.$t('pages.waiting-review.title'),
      });
    },
    fetchEnvelopeWaitingReview(page = 1) {
      this.$loading(true);
      const params = new URLSearchParams({
        ...(this.search && { q: this.search }),
        ...{ page },
        ...{ 'filter[state]': 'waiting-review' },
        ...{ sort: this.filters.sort },
      });
      EnvelopesService.listSent(params.toString())
        .then((response) => {
          this.envelopesArchived = response.data;
        })
        .catch((error) => {
          console.log('error', error);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    searchEnvelopesArchived: debounce(function searchEnvelopesArchived() {
      this.fetchEnvelopeWaitingReview();
    }, 300),
    refreshEnvelopeWaitingReview() {
      this.fetchEnvelopeWaitingReview(
        this.envelopesArchived.meta?.current_page ?? 1
      );
    },
    refreshAfterDelete() {
      const currentPage = this.envelopesArchived.meta?.current_page ?? 1;
      const isLastItemOnPage = this.envelopesArchived.data.length <= 1;
      const page =
        isLastItemOnPage && currentPage > 1 ? currentPage - 1 : currentPage;
      this.fetchEnvelopeWaitingReview(page);
    },
    setSortColumn(column) {
      this.filters.sort = `${column.desc ? '-' : ''}${column.column}`;
      this.fetchEnvelopeWaitingReview();
    },
  },
};
</script>

<style scoped lang="stylus">
.form-group
  margin-bottom: 0.5rem
  .form-control-icon--end-line
    max-width: 260px
</style>
